import React from "react";
import "./MinimumTradingDays.scss";
import { motion } from "framer-motion";
import { Tooltip, TooltipContent, TooltipTrigger } from "Components/ui/tooltip";
import UseInnerWidth from "hooks/UseInnerWidth";

function MinimumTradingDays({ data, lastActiveIndex, count }) {
  const width = UseInnerWidth();

  return (
    <div className="flex flex-row items-center gap-x-4 gap-y-2 flex-wrap hideScrollBar pt-2">
      {data?.map((item, i) => (
        <Tooltip>
          <TooltipTrigger
            className={`flex justify-center items-center rounded-full aspect-square w-10 text-sm  font-N_Bold ${
              item?.exists
                ? "bg-primary text-white"
                : "bg-background-secondaryOpacity text-white-opacity"
            }`}
          >
            {i + 1}
          </TooltipTrigger>
          <TooltipContent className="p-0 bg-transparent">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.2 }}
              className={`${"bg-background-opacity"} p-4 text-white-opacity rounded-lg font-N_Bold text-xs`}
            >
              {item?.date}
            </motion.div>
          </TooltipContent>
        </Tooltip>
      ))}
    </div>
  );
}

export default MinimumTradingDays;
